var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberOfActiveGoalSavings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6403 3.10951C6.21906 3.06332 6.7685 2.83574 7.21041 2.45915C8.24163 1.58035 9.75835 1.58035 10.7896 2.45915C11.2315 2.83574 11.7809 3.06332 12.3597 3.10951C13.7103 3.21729 14.7827 4.28977 14.8905 5.64036C14.9367 6.21912 15.1643 6.76856 15.5409 7.21047C16.4197 8.24169 16.4197 9.75841 15.5409 10.7896C15.1643 11.2315 14.9367 11.781 14.8905 12.3597C14.7827 13.7103 13.7103 14.7828 12.3597 14.8906C11.7809 14.9368 11.2315 15.1644 10.7896 15.5409C9.75835 16.4198 8.24163 16.4198 7.21041 15.5409C6.7685 15.1644 6.21906 14.9368 5.6403 14.8906C4.28971 14.7828 3.21723 13.7103 3.10945 12.3597C3.06326 11.781 2.83568 11.2315 2.45909 10.7896C1.58029 9.75841 1.58029 8.24169 2.45909 7.21047C2.83568 6.76856 3.06326 6.21912 3.10945 5.64036C3.21723 4.28977 4.28971 3.21729 5.6403 3.10951ZM12.3364 7.83644C12.6879 7.48497 12.6879 6.91512 12.3364 6.56365C11.9849 6.21218 11.4151 6.21218 11.0636 6.56365L8.09999 9.52726L6.93638 8.36365C6.58491 8.01218 6.01506 8.01218 5.66359 8.36365C5.31212 8.71512 5.31212 9.28497 5.66359 9.63645L7.46359 11.4364C7.81506 11.7879 8.38491 11.7879 8.73638 11.4364L12.3364 7.83644Z",
    fill: "#5F0056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberOfActiveGoalSavings);
export default __webpack_public_path__ + "static/media/number-of-active-goal-savings.fe78f7a3.svg";
export { ForwardRef as ReactComponent };